import cn from 'classnames';
import { ReactNode } from 'react';
import { MdChevronLeft, MdChevronRight, MdClose } from 'react-icons/md';
import { IconButton } from '@Components/IconButton';
import { GHOST_ICON_BUTTON_PROPS } from '../activity-feed-constants';
import { useSelection } from '../useActivityFeedSelection';

export const DetailHeader = (): ReactNode => {
  const { selectedIndex, totalCount, selectRelative, deselect } = useSelection();
  // Selection persists across filter/search, so the selected activity can be hidden from the
  // visible list; hide the counter (preserving layout space) when there's no meaningful "N of M".
  const isSelectedHidden = selectedIndex < 0;
  return (
    <div className='activity-feed-detail-header'>
      <div
        className={cn('activity-feed-detail-header-nav', { hidden: isSelectedHidden })}
        aria-hidden={isSelectedHidden}
      >
        <IconButton
          {...GHOST_ICON_BUTTON_PROPS}
          onClick={() => selectRelative.onBackward(selectedIndex)}
          disabled={selectRelative.backwardDisabled(selectedIndex)}
        >
          <MdChevronLeft />
        </IconButton>
        <span className='activity-feed-detail-header-count'>
          {selectedIndex + 1} of {totalCount}
        </span>
        <IconButton
          {...GHOST_ICON_BUTTON_PROPS}
          onClick={() => selectRelative.onForward(selectedIndex)}
          disabled={selectRelative.forwardDisabled(selectedIndex)}
        >
          <MdChevronRight />
        </IconButton>
      </div>
      <IconButton {...GHOST_ICON_BUTTON_PROPS} onClick={deselect}>
        <MdClose />
      </IconButton>
    </div>
  );
};
